<template>
  <div class="empty">
    {{tip || '暂无数据'}}
  </div>
</template>
<script>
export default {
  props:{
    tip:{
      type:String,
      default:""
    }
  }
}
</script>
<style lang="less" scoped>
.empty {
    background: #fff;
    margin: 20px 0;
    padding: 20px;
    color: #f60;
    font-size: 20px;
}
</style>